import { memo, useRef, useEffect, createRef } from 'react';

import { Group, ScrollArea } from '@ui';

import { Step } from './Step';

interface StepsProps {
  steps: string[];
  activeStep: number;
}

const Steps: React.FC<StepsProps> = memo(({ steps, activeStep }) => {
  // Create refs for each step
  const stepRefs = useRef<Array<React.RefObject<HTMLDivElement>>>([]);
  if (stepRefs.current.length !== steps.length) {
    stepRefs.current = steps.map((_, i) => {
      return stepRefs.current[i] || createRef<HTMLDivElement>();
    });
  }

  useEffect(() => {
    const activeIdx = activeStep - 1;
    const node = stepRefs.current[activeIdx]?.current;
    if (node) {
      node.scrollIntoView({
        behavior: 'smooth',
        inline: 'center',
        block: 'nearest'
      });
    }
  }, [activeStep, steps.length]);

  return (
    <ScrollArea w={{ base: 'calc(100dvw - 32px)', sm: '100%' }}>
      <Group wrap="nowrap" gap="lg" justify="space-between">
        {steps.map((step, index) => (
          <Step
            key={step}
            label={step}
            index={index + 1}
            active={activeStep === index + 1}
            completed={activeStep > index + 1}
            totalSteps={steps.length}
            ref={stepRefs.current[index]}
          />
        ))}
      </Group>
    </ScrollArea>
  );
});

export { Steps };
